import { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Moment from "react-moment";
import { NavLink } from "react-router-dom";
import { TableHead } from "@mui/material";
import FleetWebApi from "../Api/FleetWebApi";
import alertLabsApi from "../Api/AlertLabsApi";
import { useAuthDataContext } from "../AuthDataProvider";

function DevicesOnLocation(props) {
  const { user } = useAuthDataContext();
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [devicesOnLoc, setDevicesOnLoc] = useState(null);
  useEffect(() => {
    let isMounted = true;
    FleetWebApi.getSensorsOnLocationSummary(props.locationId).then(
      async (result) => {
        if (isMounted) {
          // Convert virtual IDs to core IDs for every device and its proxy in one batched
          // lookup, instead of up to two API calls per device (which hit the rate limit)
          const hardwareIDs = await alertLabsApi.getHardwareIDsFromSensorIDs(
            result.flatMap((device) => [device.coreID, device.latestProxy]),
            'particle',
            user?.token
          );
          const resolvedDevices = result.map((device) => ({
            ...device,
            coreID: hardwareIDs.get(device.coreID) || device.coreID,
            latestProxy: device.latestProxy
              ? hardwareIDs.get(device.latestProxy) || device.latestProxy
              : device.latestProxy,
          }));
          setDevicesOnLoc(resolvedDevices);
          if (resolvedDevices) {
            setIsLoaded(true);
          }
        }
      },
      (error) => {
        if (isMounted) {
          setError(error);
          setIsLoaded(true);
        }
      }
    );
    return () => {
      isMounted = false;
    };
  }, [props.locationId, user]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return (
      <div>
        <CircularProgress color="secondary" />
      </div>
    );
  } else if (isLoaded && devicesOnLoc.length === 0) {
    return <h3>No devices on this Location</h3>;
  } else {
    return (
      <Container maxWidth="lg">
        <Grid>
          <h3>Location Summary</h3>
          <Paper>
            <Table classes={{ root: "reactivetable" }}>
              <TableHead>
                <TableRow>
                  <TableCell>Serial</TableCell>
                  <TableCell>Core Id</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Sub-Type</TableCell>
                  <TableCell>Friendly Name</TableCell>
                  <TableCell>Firmware</TableCell>
                  <TableCell>Last Report</TableCell>
                  <TableCell>Recently Proxied by</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {devicesOnLoc.map((device, key) => (
                  <TableRow key={key + "row"}>
                    <TableCell data-th="Serial" key={key + "cell1"}>
                      <NavLink
                        to={"/device/" + device.coreID}
                        className="Nav_link"
                        key={key + "navlink"}
                      >
                        {device.serialNumber}
                      </NavLink>
                    </TableCell>
                    <TableCell key={key + "cell2"} data-th="Core ID">
                      {device.coreID}
                    </TableCell>
                    <TableCell key={key + "cell3"} data-th="Type">
                      {device.type}
                    </TableCell>
                    <TableCell key={key + "cell4"} data-th="Type">
                      {device.subtype ? device.subtype : "-"}
                    </TableCell>

                    <TableCell key={key + "cell5"} data-th="Friendly Name">
                      {device.name}
                    </TableCell>
                    <TableCell key={key + "cell6"} data-th="Firmware">
                      {device.firmwareVersion ? device.firmwareVersion : "N/A"}
                    </TableCell>
                    <TableCell data-th="lastheard" key={key + "cell7"}>
                      {device.lastSeen ? (
                        <Moment
                          key={key + "moment"}
                          format="YYYY-MM-DD HH:mm:ss Z"
                        >
                          {device.lastSeen}
                        </Moment>
                      ) : "Not Found"}
                    </TableCell>
                    <TableCell key={key + "cell"} data-th="Proxy">
                      <NavLink
                        to={"/device/" + device.latestProxy}
                        className="Nav_link"
                        key={key + "navlink"}
                      >
                        {device.latestProxy}
                      </NavLink>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </Grid>
      </Container>
    );
  }
}
export default DevicesOnLocation;
